import { error } from "jquery";
import axiosInstance from "../../../axios/axios";

export function createShowEntry(action = "", horseList = [], showId) {
    const sendedHorses = horseList.map((horse, index) => ({
        horseId: horse?.id,
    }));
    const obj = {
        showId: showId,
        actionName: action,
        showParticipantsHorsesList: sendedHorses
    }


    return new Promise((resolve, reject) => {
        axiosInstance.post('/showentry/createshowentry', { ...obj }).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    resolve(true);
                }
            }
            resolve(false);
        }).catch(error => reject(false));
    })
}
export function deleteShowEntry(horseId = "") {

    return new Promise((resolve, reject) => {
        axiosInstance.get(`/showentry/deleteshowentry?ShowHorseId=${horseId}`).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    resolve(true);
                }
            }
            resolve(false);
        }).catch(error => reject(false));
    })
}

export function getShowEntryHorses(userId = "", showId = '') {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/ShowEntry/GetShowRequest?id=${userId}&showId=${showId}`).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    resolve(response.data?.result ?? [])
                }
            }
            resolve([]);
        }).catch(error => reject(false))
    })
}
export function getCountries() {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/lookup/getcountries`).then(response => {
            if (response.status == 200) {
                const res = response.data.map((item) => ({
                    label: item?.text,
                    ...item
                }))
                resolve(res ?? [])
            }
            resolve([]);
        }).catch(error => reject([]))
    })
}
export function getHorseColors() {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/lookup/gethorsecolors`).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    const res = response.data?.result.map((item) => ({
                        label: item?.nameEn,
                        text: item?.nameEn,
                        value: item?.id,
                        ...item
                    }))
                    resolve(res ?? [])
                }
            }
            resolve([]);
        }).catch(error => reject([]))
    })
}
export function searchInternationalHorse(name = "", countryId = "", UelnNo = "") {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/showentry/searchinternationalhorses?Name=${name}&CountryId=${countryId}&UelnNo=${UelnNo}`).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    const res = response.data.result;
                    resolve(res ?? [])
                }
            }
            resolve([]);
        }).catch(error => reject([]))
    })
}

export function getInternationalHorseById(horseId) {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/showentry/getinternationalhorsesbyid?id=${horseId}`).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    const res = response.data.result;
                    resolve(res ?? [])
                }
            }
            resolve([]);
        }).catch(error => reject([]))
    })
}

export function addEditInternationalHorse(formData) {
    return new Promise((resolve, reject) => {
        axiosInstance.post(`/showentry/addeditinternationalhorse`, formData, {
            headers: {
                'content-type': 'multipart/form-data',
            }
        }).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    const res = response.data.result;
                    resolve(res ?? false)
                }
            }
            resolve(false);
        }).catch(error => reject(false))
    })

}
export function addedithorsequalification(obj) {
    return new Promise((resolve, reject) => {
        axiosInstance.post(`/showentry/addedithorsequalification`, obj,).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    const res = true;
                    resolve(res ?? false)
                }
            }
            resolve(false);
        }).catch(error => reject(false))
    })

}
export function gethorsequalificationbyhorseid(horseId) {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/showentry/gethorsequalificationbyhorseid?horseId=${horseId}`,).then(response => {
            debugger
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    const res = response.data.result;
                    resolve(res ?? false)
                }
            }
            resolve(false);
        }).catch(error => reject(false))
    })

}
